import React from 'react'

const Footer = (props) => {
  return (
    <div>
      {/* Professional Blue Gradient Footer */}
      <footer>
        <div>
          &copy; {new Date().getFullYear()} <strong>NeeBun</strong> By <span className="text-danger">Red Chilly Computers</span> &mdash; Excellence in Web & Mobile App Development
        </div>
        <div className="mt-1" style={{fontSize: '0.95rem', fontWeight: 400}}>
          <a href="#" onClick={e => {e.preventDefault(); props.onPolicyNav && props.onPolicyNav('terms')}}>Terms &amp; Conditions</a>
          <span style={{margin: '0 12px'}}>•</span>
          <a href="#" onClick={e => {e.preventDefault(); props.onPolicyNav && props.onPolicyNav('privacy')}}>Privacy Policy</a>
          <span style={{margin: '0 12px'}}>•</span>
          <a href="#" onClick={e => {e.preventDefault(); props.onPolicyNav && props.onPolicyNav('policy')}}>Our Policy</a>
        </div>
      </footer>
    </div>
  )
}

export default Footer
